<form class="h-100 d-flex flex-column flex-fill overflow-hidden" [formGroup]="productForm" (ngSubmit)="onSubmit()">
  <div class="mb-3">
    <label class="form-label">Location</label>

    @if (!locationOptions().length && !usingDefaultLocations()) {
      <p class="text-muted fs-12 mb-0 mt-1">No locations available for this option.</p>
    } @else {
      <generic-dropdown
        class="w-100"
        placeholder="Select Location"
        [items]="locationOptions()"
        [clearable]="!isLocked() || canMoveLockedOption()"
        [disabled]="isLocked() && !canMoveLockedOption()"
        formControlName="locationId"
      />
    }
  </div>
  <!-- <div class="mb-3">
                    <label class="form-label">Option Code</label>
                    <input disabled pInputText class="w-100" [value]="product().code" readonly aria-readonly="true" />
                  </div> -->
  @if (attributeFields().length) {
    <div [formGroup]="attributeValuesControl" class="d-flex flex-column gap-3 mb-3">
      @for (attribute of attributeFields(); track attribute.id) {
        <div>
          <label class="form-label">{{ attribute.name }}</label>
          <generic-dropdown
            class="w-100"
            [placeholder]="'Select ' + attribute.name"
            [items]="attribute.options"
            [clearable]="true"
            [allowSearch]="true"
            [disabled]="isLocked()"
            [formControlName]="attribute.id"
          />

          @if (!attribute.hasValues) {
            <p class="text-muted fs-12 mb-0 mt-1">No values available for this attribute.</p>
          }
        </div>
      }
    </div>
  } @else {
    <p class="text-muted fs-12 mb-3">No attributes available for this option.</p>
  }
  <div class="mb-3">
    <currency-input-field
      [label]="'Unit Price'"
      [placeholder]="'Enter'"
      formControlName="unitPrice"
      [min]="null"
      [customClass]="'form-control'"
    ></currency-input-field>
  </div>
  <div class="d-flex align-items-center justify-content-between mb-3">
    <label class="form-label m-0">Unit of Measurement</label>
    <!-- <input disabled pInputText class="w-100" [value]="product().uom" readonly aria-readonly="true" /> -->
    <span>{{ addendumOption().uofm?.name ?? addendumOption().uofm?.code ?? '—' }}</span>
  </div>
  <div class="mb-3">
    <label class="form-label">Sales description: </label>
    <p class="m-0 fs-14">{{ addendumOption().salesDescription ?? '—' }}</p>
  </div>
  <div class="mb-3">
    <label class="form-label">Option Notes</label>
    <textarea
      pTextarea
      rows="4"
      class="form-control"
      placeholder="Add Notes"
      [disabled]="isLocked()"
      formControlName="notes"
    ></textarea>
  </div>
  @if (canWriteDeals()) {
    <button
      [disabled]="isLocked()"
      class="btn btn-primary w-100 justify-content-center btn-h35"
      type="submit"
      appBtnLoader="deal-save-addendum-option-details"
    >
      Save
    </button>
  }
</form>
